export const updateItemInListOfItems = (itemsList, updatedItem) => {
    return itemsList.map( item => {
        if (item.id !== updatedItem.id) {
            return item;
        }
        return {...updatedItem};
    });
};

export const updateItemsInListOfItems = (itemsList, updatedItems) => {
    return itemsList.map( item => {
        const updatedItem = updatedItems.find(_item => _item.id === item.id);
        return updatedItem ? {...updatedItem} : item;
    });
};


export const deleteItemInListOfItems = (itemsList, deletedItem) => {
    return itemsList.filter(item => item.id !== deletedItem.id);
};

export const deleteItemByIdInListOfItems = (itemsList, deletedItemId) => {
    return itemsList.filter(item => item.id !== deletedItemId);
};

/**
 * 
 * @param {any[]} itemsList
 * @param {number[]} deletedItemIds 
 * @returns {any[]}
 */
export const deleteItemByListOfIdsInListOfItems = (itemsList = [], deletedItemIds = []) => {
    return itemsList.filter(item => !deletedItemIds.includes(item.id));
};

export const addItemInListOfItems = (itemsList, addedItem) => {
    return itemsList.concat(addedItem);
};

export const removeDuplicatedItems = (itemsList, keyCallback = (item) => item.id) => {
    const seen = new Map();
    for (const item of itemsList) {
        const key = keyCallback(item);
        // keeps the first encountered element
        if(!seen.has(key)) {
            seen.set(key, item);
        }
    }
    return Array.from(seen.values());
}


// WEBPACK FOOTER //
// ./src/helpers/reducers.js